import { DriversState } from '../types';

import { DEFAULT_ROWS_PER_PAGE } from 'app/constants/paginate';

export const driverState: DriversState = {
  drivers: [],
  subSets: [],
  terminals: [],
  hosCarrierProperties: [],
  limit: DEFAULT_ROWS_PER_PAGE,
  pageIndex: 0,
  totalRecordCount: 0,
  sortBy: 'id',
  sortField: 'name',
  recordId: '',
  homeTerminalId: [],
  createUpdateModalOpen: false,
  selectedDriverId: undefined,
  exportModalOpen: false,
  csvExportModalOpen: false,
  columns: [
    {
      id: 'name',
      field: 'name',
      header: 'Name',
      order: 0,
      isVisible: true,
      option: { width: '160px', sortBy: 'event-type' },
    },
    {
      id: 'email',
      field: 'email',
      header: 'Email',
      order: 1,
      isVisible: true,
      option: { width: '160px', sortBy: 'event-type' },
    },
    {
      id: 'terminal',
      field: 'terminal',
      header: 'Terminal',
      order: 2,
      isVisible: true,
      option: { width: '160px', sortBy: 'event-type' },
    },
    {
      id: 'active',
      field: 'active',
      header: 'Active',
      order: 3,
      isVisible: true,
      option: { width: '160px' },
    },
    {
      id: 'action',
      field: 'action',
      header: 'Action',
      order: 4,
      isVisible: true,
      option: { width: '100px' },
    },
  ],
};
